import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import Feed from '../components/feed';
import { useNavBar } from '../hooks/navBarHooks';
import { useHistory } from 'react-router-dom';
import { useLastLocation } from 'react-router-last-location';
import CustomTabs from '../components/common/customTabs';
import Hashtags from '../components/hashtags';
import CommunitiesSearch from '../components/communitiesSearch';
import SearchBar from '../components/common/searchBar';
import { getSearchStreamApiUrl } from '../utils/feedUtil';
import queryString from 'query-string';
import ShopMedia from './shopMedia';
import { getPostLanguage, getSpentTime } from '../services/authService';
import MoengageService from '../services/moEngageService';
import {
  getPreviousLocation,
  screenNamesSet,
  currentScreenOpen,
} from '../utils/screenUtils';

const Search = ({ location }) => {
  const webLanguage = getPostLanguage();
  const enHiLang = webLanguage === 'en' || webLanguage === 'hi';
  useNavBar({
    showSearchBar: true,
    activeTab: 'search',
    showBottomNavbar: true,
  });

  const searchTabs = [
    {
      title: 'Explore',
      tabKey: 'images',
      tabIndex: 0,
      showFab: false,
    },
    {
      title: 'Top',
      tabKey: 'posts',
      tabIndex: 1,
      showFab: false,
    },
    {
      title: 'People',
      tabKey: 'users',
      tabIndex: 2,
      showFab: false,
    },
    {
      title: 'Communities',
      tabKey: 'communities',
      tabIndex: 3,
      showFab: false,
    },
    {
      title: 'Hashtags',
      tabKey: 'hashtags',
      tabIndex: 4,
      showFab: false,
    },
  ];
  const spentTime = getSpentTime();
  const lastLocation = useLastLocation();
  const sourceName = getPreviousLocation(lastLocation);
  const history = useHistory();
  const qs = queryString.parse(location.search);
  const [searchValue, setSearchValue] = useState(qs.q);
  const tabId = qs.type || 'posts';
  const currentIndex = searchTabs.findIndex((tab) => {
    return tab.tabKey === tabId;
  });
  const [activeTab, setActiveTab] = useState(searchTabs[currentIndex]);
  const currentScreen = !qs.type
    ? screenNamesSet.topSearch
    : currentScreenOpen(qs);
  MoengageService.trackScreenOpen(sourceName, currentScreen, spentTime);
  const dataUrl = getSearchStreamApiUrl(searchValue, tabId);

  useEffect(() => {
    async function setTab() {
      if (qs.type === 'images') {
        setActiveTab(searchTabs[0]);
      } else if (qs.type === 'posts') {
        setActiveTab(searchTabs[1]);
      } else if (qs.type === 'users') {
        setActiveTab(searchTabs[2]);
      } else if (qs.type === 'communities') {
        setActiveTab(searchTabs[3]);
      } else if (qs.type === 'hashtags') {
        setActiveTab(searchTabs[4]);
      }
    }
    setTab();
    // eslint-disable-next-line
  }, [qs.type, setActiveTab]);
  function handleTabSwitch(tabInfo) {
    const path = makePath(tabInfo.tabKey, searchValue);
    history.push(path);
    setActiveTab(tabInfo);
    MoengageService.trackScreenOpen(sourceName, currentScreen, spentTime);
  }

  function handleSubmit(value) {
    const path = makePath(tabId, value);
    history.push(path);
    setSearchValue(value);
  }
  function makePath(tabId, value) {
    const qs = {
      type: tabId || 'posts',
      q: value || undefined,
    };
    return {
      search: queryString.stringify(qs),
    };
  }
  return (
    <React.Fragment>
      {enHiLang && (
        <SearchBar
          searchValue={searchValue}
          handleSubmit={handleSubmit}
          type={tabId}
        />
      )}
      <CustomTabs
        activeTabKey={activeTab.tabKey}
        activeTabIndex={activeTab.tabIndex}
        tabs={searchTabs}
        handleTabSwitch={handleTabSwitch}
      />
      {dataUrl && tabId !== 'images' && (
        <Box mt={2}>
          <Feed
            showFab={false}
            isGetRequest={!!searchValue}
            feedStreamApi={dataUrl}
          />
        </Box>
      )}
      {tabId === 'images' && (
        <Box width={1}>
          <ShopMedia qs={qs} streamSearchUrl={dataUrl} />
        </Box>
      )}
      {!searchValue && tabId === 'communities' && (
        <Box width={1}>
          <CommunitiesSearch />
        </Box>
      )}
      {!searchValue && tabId === 'hashtags' && (
        <Box width={1} py={2} px={4}>
          <Hashtags handleSubmit={handleSubmit} />
        </Box>
      )}
    </React.Fragment>
  );
};

export default Search;
